define('geo/geocoder',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.parseLatLng = exports.parseLatLngAlt = void 0;
    /**
     * Takes in a lat,lon,alt string and returns an object.
     * Throws exceptions for invalid input.
     */
    function parseLatLngAlt(str) {
        if (!str) {
            throw new Error("Missing latitude, longitude, altitude");
        }
        var split = str.split(",");
        if (split.length === 2) {
            throw new Error("Missing altitude");
        }
        if (split.length <= 2 || split.length > 3) {
            throw new Error("Invalid latitude, longitude, altitude");
        }
        // Parse lat, lng, alt
        var lat = parseLat(split[0]);
        var lng = parseLng(split[1]);
        var alt = parseAlt(split[2]);
        return { lat: lat, lng: lng, alt: alt };
    }
    exports.parseLatLngAlt = parseLatLngAlt;
    /**
     * Takes in a lat,lon string and returns an object.
     * Throws exceptions for invalid input.
     */
    function parseLatLng(str) {
        if (!str) {
            throw new Error("Missing latitude, longitude");
        }
        var split = str.split(",");
        if (split.length < 1 || split.length > 2) {
            throw new Error("Invalid latitude, longitude");
        }
        // Parse lat, lng
        var lat = parseLat(split[0]);
        var lng = parseLng(split[1]);
        return { lat: lat, lng: lng };
    }
    exports.parseLatLng = parseLatLng;
    function parseLat(latStr) {
        latStr = latStr && latStr.trim() || "";
        if (!latStr) {
            throw new Error("Missing latitude");
        }
        var lat = Number(latStr);
        if (isNaN(lat)) {
            throw new Error("Invalid latitude: " + latStr.trim());
        }
        if (lat < -90 || lat > 90) {
            throw new Error("Invalid latitude: " + latStr.trim() + " is not between -90 and 90");
        }
        return lat;
    }
    function parseLng(lngStr) {
        lngStr = lngStr && lngStr.trim() || "";
        if (!lngStr) {
            throw new Error("Missing longitude");
        }
        var lng = Number(lngStr);
        if (isNaN(lng)) {
            throw new Error("Invalid longitude: " + lngStr.trim());
        }
        if (lng < -180 || lng > 180) {
            throw new Error("Invalid longitude: " + lngStr.trim() + " is not between -180 and 180");
        }
        return lng;
    }
    function parseAlt(altStr) {
        altStr = altStr && altStr.trim() || "";
        if (!altStr) {
            throw new Error("Missing altitude");
        }
        var alt;
        if (altStr.endsWith("ft")) {
            alt = parseNumber(altStr.substring(0, altStr.length - 2)) * 0.3048;
        }
        else if (altStr.endsWith("m")) {
            alt = parseNumber(altStr.substring(0, altStr.length - 1));
        }
        else {
            alt = parseNumber(altStr);
        }
        if (isNaN(alt)) {
            throw new Error("Invalid altitude: " + altStr.trim());
        }
        return alt;
    }
    /**
     * Parse a string into a double, but use NaN for non-real
     * Stricter version of Number(str).
     */
    function parseNumber(str) {
        if (str.trim() === "") {
            return NaN;
        }
        else {
            var n = Number(str);
            if (isFinite(n)) {
                return n;
            }
            else {
                return NaN;
            }
        }
    }
});
//# sourceMappingURL=/assets/javascripts/geo/geocoder.js.map;
